// ChatDataQualityCard (plan todo 23) — getDataQuality tool result rendered as
// a warning-toned card with the concrete improvement actions the engine
// returned, plus an Open-in-Plan navigation action.

import { TriangleAlert } from "lucide-react";
import type { DataQualityData } from "./card-data";
import { ChatCardShell, MacroChip, OpenInButton } from "./card-ui";

export interface ChatDataQualityCardProps {
  readonly data: DataQualityData;
  readonly onSwitchScreen?: (screen: string) => void;
}

export function ChatDataQualityCard({ data, onSwitchScreen }: ChatDataQualityCardProps) {
  const tone = data.dataQuality === "high" ? "accent" : "warning";
  return (
    <ChatCardShell
      icon={TriangleAlert}
      title="Data quality"
      subtitle={data.dataQuality === "high" ? "Your logs are in good shape" : "Better logs mean better targets"}
      testId="chat-card-data-quality"
      tone={tone}
    >
      <div className="flex flex-wrap gap-1.5" data-testid="data-quality-chips">
        <MacroChip label="Quality" value={data.dataQuality} />
        {data.trendConfidence !== undefined && (
          <MacroChip label="Trend" value={data.trendConfidence} />
        )}
        {data.expenditureConfidence !== undefined && (
          <MacroChip label="Expenditure" value={data.expenditureConfidence} />
        )}
      </div>
      {data.actions.length > 0 && (
        <ul className="flex flex-col gap-1.5 text-xs leading-relaxed text-text-muted" data-testid="data-quality-actions">
          {data.actions.slice(0, 3).map((action) => (
            <li key={action} className="flex items-start gap-2">
              <span aria-hidden className="mt-1.5 inline-block h-1 w-1 shrink-0 rounded-full bg-text-muted/60" />
              {action}
            </li>
          ))}
        </ul>
      )}
      <OpenInButton
        label="Open in Plan"
        screen="plan"
        testId="data-quality-open-btn"
        onSwitchScreen={onSwitchScreen}
      />
    </ChatCardShell>
  );
}
